import { useQuery } from "@tanstack/react-query";

import { AppointmentResponse, appointmentsApi } from "@/api";
import { QueryKey } from "@/query/Query";

interface Result {
  appointments: AppointmentResponse[];
  isLoading: boolean;
}

const LOOKAHEAD_MONTHS = 1;

export function useAvailableAppointmentsQuery(startDate: Date): Result {
  const startOfDay = new Date(startDate);
  startOfDay.setHours(0, 0, 0, 0);

  const endDate = new Date(startOfDay);
  endDate.setMonth(endDate.getMonth() + LOOKAHEAD_MONTHS);

  const { data, isLoading } = useQuery({
    queryKey: [QueryKey.Appointments, "available-1b", startOfDay.toISOString()],
    queryFn: () =>
      appointmentsApi.getAvailable1bAppointments({
        startDate: startOfDay,
        endDate,
      }),
  });

  return { appointments: data ?? [], isLoading };
}
